import { IsNotEmpty, IsString } from 'class-validator';

export class TaxonomyReferenceItemGetListOfAllowedParentsRequest {
    @IsString()
    @IsNotEmpty()
    public itemUuid: string;

    constructor(data?: Partial<TaxonomyReferenceItemGetListOfAllowedParentsRequest>) {
        this.itemUuid = data?.itemUuid;
    }
}
